@if (notifikationer().length === 0) {
  <div>Brugeren abonnerer ikke på nogen notifikationer</div>
} @else {
  @for (bn of notifikationer(); track bn.id) {
    <div>{{ bn.notifikationType.navn }}</div>
  }
}
